import { objectSpread2 as _objectSpread2, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, Collapse, FormHelperText } from '@mui/material';
import TransitionGroup from '../../node_modules/react-transition-group/esm/TransitionGroup.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _templateObject;
var componentErrors = createComponentSlot({
  name: "CinForm",
  slot: "Errors"
});
var componentError = createComponentSlot({
  name: "CinForm",
  slot: "Error"
});

var FieldErrorBase = function FieldErrorBase(_ref) {
  var errors = _ref.errors,
      animate = _ref.animate,
      className = _ref.className;
  var duration = typeof animate === "number" ? animate : animate === false ? 0 : 500;
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    className: componentErrors.className
  }, (errors !== null && errors !== void 0 ? errors : []).filter(function (e) {
    return !!e;
  }).map(function (e) {
    return /*#__PURE__*/React.createElement(Collapse, {
      key: e,
      timeout: duration,
      appear: true
    }, /*#__PURE__*/React.createElement(FormHelperText, {
      error: true,
      className: classnames(componentError.className, className)
    }, e));
  }));
};
/**
 * Displays a collection of errors for a form field
 */


FieldErrorBase.propTypes = {
  errors: propTypes.arrayOf(propTypes.string),
  animate: propTypes.oneOfType([propTypes.bool, propTypes.number]),
  className: propTypes.string
};
var FieldError = styled(FieldErrorBase, _objectSpread2(_objectSpread2({}, componentError.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var FieldError$1 = FieldError;

export { FieldError$1 as default };
